import React from 'react'
import { Route, Switch } from 'react-router'
import ReportAppUsage from './ReportAppUsage'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportAppUsage} />
    </Switch>
)

export default Components
